import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
const CreditOrderHistoryB2BDetail = ({ onDismiss }) => {
    const { order } = useSelector((state) => state.myPage.creditOrders);
    return (
        <div className="order-detail__container">
            <div className="row-inner small-12 order-detail__button-container">
                <div>
                    <a className="order-detail__button" onClick={onDismiss}>
                        {translate('orderdetail.backtoorderlist')}
                    </a>
                </div>
            </div>
            <div className="row-inner">
                <div className="medium-6">
                    <h3>
                        {translate('orderdetail.ordernumber')}: {order?.externalOrderID}
                    </h3>
                </div>
                <div className="medium-6 text--right order-detail__status-container">
                    <p>
                        <span>
                            {translate('orderdetail.orderdate')}: {order?.orderDate}
                        </span>
                    </p>
                </div>
            </div>
            <div className="row-inner order-detail__information-container">
                <div className="small-12">
                    <div className="row medium-unstack no-margin">
                        <div className="medium-12">{translate('orderdetail.information')}</div>
                    </div>
                    <div className="row no-margin">
                        <div className="medium-12">
                            <p>
                                {order?.customerInfo?.address1}
                                <br />
                                {order?.customerInfo?.zip} {order?.customerInfo?.city} <br />
                                {order?.customerInfo?.country}
                            </p>
                            <p>
                                {translate('orderdetail.organizationnumber')}:{' '}
                                {order?.merchantOrganizationNumber}
                                <br />
                                {translate('orderdetail.orderreference')}:{' '}
                                {order?.customerInfo?.firstName} {order?.customerInfo?.lastName}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row-inner order-table-detail">
                <div className="row medium-unstack no-margin order-table-detail__header hide-for-small-only">
                    <div className="columns order-table-detail__header--cell">
                        {translate('orderdetail.column.products')}
                    </div>
                    <div className="columns  order-table-detail__header--cell">
                        {translate('orderdetail.column.deliverydate')}
                    </div>
                    <div className="columns order-table-detail__header--cell">
                        {translate('orderdetail.column.quantity')}
                    </div>
                    <div className="columns order-table-detail__header--cell">
                        {translate('orderdetail.column.price')}
                    </div>
                    <div className="columns order-table-detail__header--cell">
                        {translate('orderdetail.column.headerdiscount')}
                    </div>
                    <div className="columns text--right order-table-detail__header--cell">
                        {translate('orderdetail.column.total')}
                    </div>
                </div>
                <div className="order-table__body">
                    {order?.consumerOrder && order?.resellerAddress &&
                        <p>
                            <strong>{translate("common.orderdetail.resellerdelivery")}</strong><br/>
                            {order?.resellerAddress.careOf}<br/>
                            {order?.resellerAddress.address1}<br/>
                            {order?.resellerAddress.zipCode} {order?.resellerAddress.city}<br/>
                            {order?.resellerAddress.country}<br/>
                        </p>
                    }
                    {order?.orderRows?.map((row, index) => (
                        <div
                            key={index}
                            className="row medium-unstack no-margin order-table-detail__row"
                        >
                            <div className="columns  order-table-detail__row--cell">
                                <a
                                    href={row.link?.href}
                                    target="_parent"
                                    className="order-detail__product-link "
                                >
                                    {row.brand} <strong>{row.name}</strong>
                                </a>
                                {row.partRows.map((partRow, partIndex) => (
                                    <Fragment key={`partrow-name-${partIndex}`}>
                                        <div className="order-detail__product-part">
                                            {partRow.brand} <strong>{partRow.name}</strong>
                                        </div>
                                    </Fragment>
                                ))}
                            </div>
                            <div className="columns order-table-detail__row--cell">
                                {row.deliveryDate}
                                {row.partRows.map((partRow, partIndex) => (
                                    <Fragment key={`partrow-date-${partIndex}`}>
                                        <div>{partRow.deliveryDate}</div>
                                    </Fragment>
                                ))}
                            </div>
                            <div className="columns order-table-detail__row--cell">
                                {row.quantityString}
                                {row.partRows.map((partRow, partIndex) => (
                                    <Fragment key={`partrow-quantity-${partIndex}`}>
                                        <div>{partRow.quantityString}</div>
                                    </Fragment>
                                ))}
                            </div>
                            <div className="columns order-table-detail__row--cell">
                                <div>
                                {row.partRows.length == 0 &&
                                    <>
                                        {row.isFreeGift && row.priceInfo?.formattedCampaignPrice ? (
                                            <span>{row.priceInfo?.formattedCampaignPrice}</span>
                                        ) : (
                                            <span>{row.priceInfo?.formattedPrice}</span>
                                        )}
                                    </>
                                }
                                &nbsp;</div>
                                {row.partRows.map((partRow, partIndex) => (
                                    <div key={`partrow-price-${partIndex}`}>
                                        {partRow.isFreeGift && partRow.priceInfo?.formattedCampaignPrice ? (
                                            <span>{partRow.priceInfo?.formattedCampaignPrice}</span>
                                        ) : (
                                            <span>{partRow.priceInfo?.formattedPrice}</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="columns order-table-detail__row--cell">
                                {row.discountPercentage}
                            </div>
                            <div className="columns order-table-detail__row--cell text--right">
                                <div>
                                    {row.partRows.length == 0 &&
                                        <>
                                            {row.totalPrice}
                                        </>
                                    }
                                &nbsp;</div>
                                {row.partRows.map((partRow, partIndex) => (
                                    <div key={`partrow-total-${partIndex}`}>
                                        {partRow.totalPrice}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                    {order?.discountRows?.map((row, index) => (
                        <div
                            key={index}
                            className="row medium-unstack no-margin order-detail__summary-items"
                        >
                            <div className="columns medium-5">{row.name}</div>                            
                            <div className="columns medium-7 text--right">{row.totalPrice}</div>
                        </div>
                    ))}
                    <div className="row medium-unstack no-margin order-detail__summary-method">
                        <div className="columns medium-9">
                            {translate('orderdetail.paymentmethod')} -{order?.paymentMethod}
                        </div>
                        <div className="columns medium-3 text--right">{order?.orderTotalFee}</div>
                    </div>
                    <div className="row medium-unstack no-margin order-detail__summary-method">
                        <div className="columns medium-9">
                            {translate('orderdetail.deliverymethod')} - {order?.deliveryMethod}
                        </div>
                        <div className="columns medium-3 text--right">
                            {order?.orderTotalDeliveryCost}
                        </div>
                    </div>
                    {order?.orderTotalDiscountAmount && (
                        <div className="row medium-unstack no-margin order-detail__summary-method">
                            <div className="columns medium-9">
                                {translate('orderdetail.discount')}
                            </div>
                            <div className="columns medium-3 text--right">
                                {order?.orderTotalDiscountAmount}
                            </div>
                        </div>
                    )}
                    <div className="row medium-unstack no-margin order-table__space-delimiter"></div>
                    <div className="row medium-unstack no-margin">
                        <div className="columns small-12 text--right">
                            {translate('orderdetail.grandtotal')}:{' '}
                            <strong>{order?.orderGrandTotal}</strong>
                        </div>
                    </div>
                    <div className="row medium-unstack no-margin">
                        <div className="columns small-12 text--right">
                            {translate('orderdetail.ordertotalvat')}: {order?.orderTotalVat}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CreditOrderHistoryB2BDetail;